export { default as ThemedBadge } from './badges';
